"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[271],{

/***/ 5693:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ TopBanners; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89703);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97204);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(76365);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(95889);
/* harmony import */ var _teko_ds_icon__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(95420);
/* harmony import */ var _Common_CustomLink_CustomLink_es_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(33153);





const TopBannerHeight = _teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled.div */ .z.div `
  height: 56px;
  position: relative;
  .swiper-slide {
    transition-property: opacity !important;
  }
  @media print {
    display: none;
  }
`;
const ButtonClose = _teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled.button */ .z.button `
  position: absolute;
  right: 10px;
  top: 16px;
  background-color: transparent;
  border: 0;
`;
const TopBanners = ({ banners, onClose, }) => (react__WEBPACK_IMPORTED_MODULE_0__.createElement(TopBannerHeight, null,
    react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ui__WEBPACK_IMPORTED_MODULE_2__/* .Swiper */ .t, { effect: "fade", autoplay: {
            delay: 5000,
            waitForTransition: false,
            disableOnInteraction: false,
        }, loop: true, slidesPerView: 1 }, banners.map((banner, index) => {
        return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { key: index, className: "swiper-slide" },
            react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Common_CustomLink_CustomLink_es_js__WEBPACK_IMPORTED_MODULE_3__/* .CustomLink */ .x, { targetPath: banner.targetPath },
                react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ui__WEBPACK_IMPORTED_MODULE_4__/* .LazyImage */ .w, { imageWidth: 1920, cover: true, height: 56, src: banner.image, alt: banner.campaignName }))));
    })),
    onClose && (react__WEBPACK_IMPORTED_MODULE_0__.createElement(ButtonClose, { onClick: onClose },
        react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_5__/* .CloseOutlined */ .X, { color: "#FFF" })))));




/***/ }),

/***/ 76365:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ Swiper; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(91806);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89703);
/* harmony import */ var swiper_react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(18668);
/* harmony import */ var swiper_react__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(49713);
/* harmony import */ var swiper_core__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(79215);
/* harmony import */ var swiper_core__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(9221);
/* harmony import */ var swiper_core__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(46626);
/* harmony import */ var _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97204);
/* harmony import */ var _atoms_SvgIcon_icons_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(16966);







const Wrapper = _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__/* .styled.div */ .z.div(({ theme }) => `.swiper-container {
  margin-left: auto;
  margin-right: auto;
  position: relative;
  overflow: hidden;
  list-style: none;
  padding: 0;
  z-index: 1;
}
.swiper-wrapper {
  position: relative;
  width: 100%;
  height: 100%;
  z-index: 1;
  display: flex;
  transition-property: transform;
  box-sizing: content-box;
}
.swiper-slide {
  flex-shrink: 0;
  width: 100%;
  height: 100%;
  position: relative;
  transition-property: transform;
}
&:hover {
  .swiper-button-next,
  .swiper-button-prev {
    opacity: 1;
    &.swiper-button-disabled {
      opacity: 0.35;
    }
  }
}
.swiper-button-prev,
.swiper-button-next {
  position: absolute;
  top: 50%;
  z-index: 10;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  margin-top: -22px;
  background-color: rgba(168, 168, 168, 0.46);
  opacity: 0;
  &.swiper-button-disabled {
    opacity: 0;
    cursor: auto;
    pointer-events: auto;
  }
}
.swiper-pagination {
position: absolute;
text-align: center;
transform: translate3d(0, 0, 0);
z-index: 10;
}
.swiper-pagination-bullet {
  width: 8px;
  height: 8px;
  display: inline-block;
  border-radius: 100%;
  background: #ddd;
}
.swiper-container-horizontal {
z-index: 0;
}
.swiper-container-horizontal > .swiper-pagination-bullets .swiper-pagination-bullet {
  margin: 0 4px;
  cursor: pointer;
}
.swiper-container-horizontal > .swiper-pagination-bullets {
  bottom: 10px;
  left: 0;
  width: 100%;
}
.swiper-pagination-bullet-active {
  background: ${theme.brand.secondary};
  width: 24px;
  border-radius: 8px;
}
.swiper-button-next {
  right: 0;
  left: auto;
  border-top-left-radius: 100px;
  border-bottom-left-radius: 100px;
  &:after {
    mask: url("${_atoms_SvgIcon_icons_es_js__WEBPACK_IMPORTED_MODULE_2__/* .iconMap["chevron-forward"] */ .q["chevron-forward"]}");
    content: ' ';
    height: 30px;
    width: 30px;
    mask-size: contain;
    display: inline-block;
    background: #333;
  }
}
.swiper-button-prev {
left: 0;
right: auto;
border-top-right-radius: 100px;
border-bottom-right-radius: 100px;
&:after {
  mask: url("${_atoms_SvgIcon_icons_es_js__WEBPACK_IMPORTED_MODULE_2__/* .iconMap["chevron-back"] */ .q["chevron-back"]}");
  content: ' ';
  height: 30px;
  width: 30px;
  mask-size: contain;
  display: inline-block;
  background: #333;
}
}`);
const Swiper = (_a) => {
    var { children, hasNavigation, hasPagination, className } = _a, props = (0,tslib__WEBPACK_IMPORTED_MODULE_3__/* .__rest */ ._T)(_a, ["children", "hasNavigation", "hasPagination", "className"]);
    const swiperProps = Object.assign({}, props);
    if (hasNavigation && !props.navigation) {
        swiperProps.navigation = true;
        swiper_core__WEBPACK_IMPORTED_MODULE_4__/* ["default"].use */ .Z.use([swiper_core__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z]);
    }
    if (hasPagination && !props.pagination) {
        swiperProps.pagination = true;
        swiper_core__WEBPACK_IMPORTED_MODULE_4__/* ["default"].use */ .Z.use([swiper_core__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z]);
    }
    const { slidesPerView = 'auto' } = swiperProps;
    const renderContent = (e, index, slidesPerView) => {
        return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(swiper_react__WEBPACK_IMPORTED_MODULE_7__/* .SwiperSlide */ .o, { style: {
                maxWidth: (slidesPerView === 'auto' ? 100 : 100 / slidesPerView) + '%',
            }, key: index }, e));
    };
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, { className: className },
        react__WEBPACK_IMPORTED_MODULE_0__.createElement(swiper_react__WEBPACK_IMPORTED_MODULE_8__/* .Swiper */ .t, Object.assign({}, swiperProps), react__WEBPACK_IMPORTED_MODULE_0__.Children.map(children, (e, index) => renderContent(e, index, slidesPerView)))));
};




/***/ }),

/***/ 60271:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Layout": function() { return /* binding */ Layout; }
});

// EXTERNAL MODULE: ../../.yarn/cache/react-npm-17.0.2-99ba37d931-b254cc17ce.zip/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(20348);
// EXTERNAL MODULE: ../../.yarn/cache/react-npm-17.0.2-99ba37d931-b254cc17ce.zip/node_modules/react/index.js
var react = __webpack_require__(89703);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-a1ca3a7fda/1/packages/ecommerce/dist/Layout/Footer/Footer.es.js + 1 modules
var Footer_es = __webpack_require__(32715);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-f5d553f239/1/packages/ui/dist/components/molecules/ScrollTopArrow/ScrollTopArrow.es.js
var ScrollTopArrow_es = __webpack_require__(67722);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@emotion-styled-virtual-2f2a2ef1d7/0/cache/@emotion-styled-npm-11.3.0-a31c55914d-5e5c1e89d2.zip/node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 1 modules
var emotion_styled_browser_esm = __webpack_require__(59802);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-a1ca3a7fda/1/packages/ecommerce/dist/TopBanners/TopBanners.es.js
var TopBanners_es = __webpack_require__(5693);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-a1ca3a7fda/1/packages/ecommerce/dist/Common/Messenger/Messenger.es.js + 2 modules
var Messenger_es = __webpack_require__(98274);
// EXTERNAL MODULE: ./i18n.ts
var i18n = __webpack_require__(17963);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-icon-virtual-b83ad4c2c5/1/packages/ds-icon/dist/components/ShowroomOutlined.es.js
var ShowroomOutlined_es = __webpack_require__(18243);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-icon-virtual-b83ad4c2c5/1/packages/ds-icon/dist/components/HeadphoneOutlined.es.js
var HeadphoneOutlined_es = __webpack_require__(84440);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-icon-virtual-b83ad4c2c5/1/packages/ds-icon/dist/components/TvNewOutlined.es.js
var TvNewOutlined_es = __webpack_require__(69853);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-icon-virtual-b83ad4c2c5/1/packages/ds-icon/dist/helpers/IconBase.es.js + 1 modules
var IconBase_es = __webpack_require__(80711);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ds-icon-virtual-b83ad4c2c5/1/packages/ds-icon/dist/components/BuildPcOutlined.es.js


const BuildPcOutlined = (props) => {
    return (0,IconBase_es/* GenIcon */.w_)({
        tag: 'svg',
        attr: { version: '1.1', viewBox: '0 0 1024 1024' },
        child: [
            { tag: 'title', attr: {} },
            { tag: 'g', attr: { id: 'icomoon-ignore' }, child: [] },
            {
                tag: 'path',
                attr: {
                    d: 'M512 0c-282.77 0-512 229.23-512 512s229.23 512 512 512c282.77 0 512-229.23 512-512v0c-0.355-282.627-229.374-511.645-511.967-512h-0.033zM580.27 765.952v184.658c-20.517 3.258-44.173 5.119-68.265 5.119s-47.748-1.861-70.834-5.448l2.569 0.329v-185.344c-0.086-14.194-8.683-26.36-20.941-31.657l-0.225-0.087c-88.406-36.411-149.506-121.894-149.506-221.647 0-80.881 40.168-152.381 101.643-195.638l0.759-0.506v128c0 0.052 0 0.113 0 0.174 0 7.666 2.568 14.733 6.89 20.387l-0.059-0.081c29.893 39.556 76.845 64.853 129.705 64.853s99.812-25.297 129.409-64.445l0.295-0.408c4.263-5.573 6.831-12.639 6.831-20.306 0-0.061 0-0.123 0-0.184v0.009-127.652c62.41 43.544 102.732 115.001 102.732 195.876 0 23.36-3.364 45.935-9.634 67.266l0.424-1.684c-20.088 71.942-71.751 128.874-138.712 155.775l-1.576 0.559c-12.683 5.383-21.431 17.702-21.504 32.073v0.009zM648.54 934.226v-146.084c77.952-38.514 135.984-107.365 159.237-190.72l0.507-2.129c7.177-24.776 11.305-53.236 11.305-82.66 0-128.341-78.537-238.338-190.172-284.555l-2.043-0.749c-3.777-1.636-8.175-2.587-12.796-2.587-7.099 0-13.673 2.246-19.050 6.066l0.102-0.069c-9.026 6.325-14.889 16.631-15.022 28.314v172.391c-17.177 18.096-41.406 29.354-68.265 29.354s-51.088-11.258-68.226-29.313l-0.039-0.041v-172.708c-0.133-11.703-5.996-22.009-14.91-28.26l-0.112-0.074c-5.35-3.663-11.962-5.85-19.085-5.85-4.56 0-8.911 0.896-12.886 2.522l0.227-0.082c-113.782 46.71-192.452 156.65-192.452 284.964 0 119.895 68.684 223.748 168.852 274.358l1.758 0.805v147.108c-179.783-59.423-307.22-225.938-307.22-422.218 0-245.071 198.669-443.74 443.74-443.74 245.068 0 443.736 198.665 443.74 443.732v0c-0.956 195.966-127.961 362.019-304.050 421.306l-3.15 0.92z',
                },
            },
        ],
    })(props);
};



// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-a3f946df97/1/packages/teko-ecommerce/dist/components/Topbar/TopbarButton.es.js
var TopbarButton_es = __webpack_require__(81889);
// EXTERNAL MODULE: ./components/desktop/organisms/LanguageSelector.tsx
var LanguageSelector = __webpack_require__(60240);
;// CONCATENATED MODULE: ./tenants/phongvu/desktop/_module/Layout.data.tsx






// TODO: remove this dependency
var supportedPhone = '1800 6865';
var clientConsultantPhone = '1800 6867';
var getRightMenu = function() {
    return [
        /*#__PURE__*/ (0,jsx_runtime.jsx)(TopbarButton_es/* TopbarButton */.S, {
            href: "/contact",
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(ShowroomOutlined_es/* ShowroomOutlined */.E, {
                color: "white",
                size: 18
            }),
            tracking: {
                isTrackContent: true,
                regionName: 'taskbar',
                contentName: 'showroomListURL'
            },
            children: (0,i18n.t)('Hệ thống Showroom')
        }, 1),
        /*#__PURE__*/ (0,jsx_runtime.jsxs)(TopbarButton_es/* TopbarButton */.S, {
            href: "tel:".concat(clientConsultantPhone.split(' ').join('')),
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(HeadphoneOutlined_es/* HeadphoneOutlined */.g, {
                color: "white",
                size: 18
            }),
            tracking: {
                isTrackContent: true,
                regionName: 'taskbar',
                contentName: 'hotlineSupportURL'
            },
            children: [
                (0,i18n.t)('Tư vấn mua h\xe0ng:'),
                ' ',
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "highlight",
                    children: clientConsultantPhone
                })
            ]
        }, 2),
        /*#__PURE__*/ (0,jsx_runtime.jsxs)(TopbarButton_es/* TopbarButton */.S, {
            href: "tel:".concat(supportedPhone.split(' ').join('')),
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(HeadphoneOutlined_es/* HeadphoneOutlined */.g, {
                color: "white",
                size: 18
            }),
            tracking: {
                isTrackContent: true,
                regionName: 'taskbar',
                contentName: 'hotlineSupportURL'
            },
            children: [
                (0,i18n.t)('CSKH'),
                ": ",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "highlight",
                    children: supportedPhone
                })
            ]
        }, 3),
        /*#__PURE__*/ (0,jsx_runtime.jsx)(TopbarButton_es/* TopbarButton */.S, {
            href: "https://phongvu.vn/cong-nghe/",
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(TvNewOutlined_es/* TvNewOutlined */.a, {
                color: "white",
                size: 18
            }),
            tracking: {
                isTrackContent: true,
                regionName: 'taskbar',
                contentName: 'techNewsURL'
            },
            children: (0,i18n.t)('Tin c\xf4ng nghệ')
        }, 4),
        /*#__PURE__*/ (0,jsx_runtime.jsx)(TopbarButton_es/* TopbarButton */.S, {
            href: "/buildpc",
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(BuildPcOutlined, {
                color: "white",
                size: 18
            }),
            tracking: {
                isTrackContent: true,
                regionName: 'taskbar',
                contentName: 'buildpcURL'
            },
            children: (0,i18n.t)('X\xe2y dựng cấu h\xecnh')
        }, 5),
        /*#__PURE__*/ (0,jsx_runtime.jsx)(LanguageSelector/* LanguageSelector */.$, {}, 6), 
    ];
};
var getFooterData = function() {
    return {
        supportAndPolicy: [
            {
                title: (0,i18n.t)('Hỗ trợ kh\xe1ch h\xe0ng'),
                links: [
                    {
                        children: (0,i18n.t)('Thẻ ưu đ\xe3i'),
                        href: 'https://help.phongvu.vn/dich-vu-khach-hang/the-thanh-vien',
                        target: '_blank',
                        rel: 'noreferrer noopener'
                    },
                    {
                        children: (0,i18n.t)('Trung t\xe2m bảo h\xe0nh'),
                        href: 'https://help.phongvu.vn/chinh-sach-ban-hang/bao-hanh#trung-tam-bao-hanh-phong-vu',
                        target: '_blank',
                        rel: 'noreferrer noopener'
                    },
                    {
                        children: (0,i18n.t)('Thanh to\xe1n v\xe0 giao h\xe0ng'),
                        href: 'https://help.phongvu.vn/chinh-sach-ban-hang/phuong-thuc-thanh-toan',
                        target: '_blank',
                        rel: 'noreferrer noopener'
                    },
                    {
                        children: (0,i18n.t)('Dịch vụ sửa chữa v\xe0 bảo tr\xec'),
                        href: 'https://help.phongvu.vn/dich-vu-khach-hang/dich-vu-sua-chua-va-bao-tri',
                        target: '_blank',
                        rel: 'noreferrer noopener'
                    },
                    {
                        children: (0,i18n.t)('Doanh nghiệp th\xe2n thiết'),
                        href: 'https://help.phongvu.vn/dich-vu-khach-hang/doanh-nghiep-than-thiet',
                        target: '_blank',
                        rel: 'noreferrer noopener'
                    }, 
                ]
            },
            {
                title: (0,i18n.t)('Ch\xednh s\xe1ch Mua h\xe0ng v\xe0 Bảo h\xe0nh'),
                links: [
                    {
                        children: (0,i18n.t)('Quy định chung'),
                        href: 'https://help.phongvu.vn/chinh-sach-ban-hang/',
                        target: '_blank',
                        rel: 'noreferrer noopener'
                    },
                    {
                        children: (0,i18n.t)('Ch\xednh s\xe1ch Bảo mật Th\xf4ng tin'),
                        href: 'https://help.phongvu.vn/chinh-sach-chung/bao-mat-thong-tin',
                        target: '_blank',
                        rel: 'noreferrer noopener'
                    },
                    {
                        children: (0,i18n.t)('Ch\xednh s\xe1ch Vận chuyển v\xe0 Lắp đặt'),
                        href: 'https://help.phongvu.vn/chinh-sach-ban-hang/van-chuyen-va-lap-dat',
                        target: '_blank',
                        rel: 'noreferrer noopener'
                    },
                    {
                        children: (0,i18n.t)('Ch\xednh s\xe1ch bảo h\xe0nh'),
                        href: 'https://help.phongvu.vn/chinh-sach-ban-hang/bao-hanh'
                    },
                    {
                        children: (0,i18n.t)('Ch\xednh s\xe1ch đổi trả v\xe0 ho\xe0n tiền'),
                        href: 'https://help.phongvu.vn/chinh-sach-ban-hang/doi-tra-va-hoan-tien',
                        target: '_blank',
                        rel: 'noreferrer noopener'
                    },
                    {
                        children: (0,i18n.t)('Quy định gi\xe1 cả v\xe0 h\xecnh thức thanh to\xe1n'),
                        href: 'https://help.phongvu.vn/chinh-sach-chung/gia-ca-va-hinh-thuc-thanh-toan',
                        target: '_blank',
                        rel: 'noreferrer noopener'
                    },
                    {
                        children: (0,i18n.t)('Ch\xednh s\xe1ch trả g\xf3p'),
                        href: 'https://help.phongvu.vn/chinh-sach-ban-hang/tra-gop',
                        target: '_blank',
                        rel: 'noreferrer noopener'
                    }, 
                ]
            },
            {
                title: (0,i18n.t)('Th\xf4ng tin Phong Vũ'),
                links: [
                    {
                        children: (0,i18n.t)('Giới thiệu Phong Vũ'),
                        href: 'https://help.phongvu.vn/',
                        target: '_blank',
                        rel: 'noreferrer noopener'
                    },
                    {
                        children: (0,i18n.t)('Th\xf4ng tin li\xean hệ'),
                        href: '/contact'
                    },
                    {
                        children: (0,i18n.t)('Hệ thống Showroom'),
                        href: '/contact'
                    },
                    {
                        children: (0,i18n.t)('Hỏi đ\xe1p'),
                        href: 'https://phongvu.vn/hoi-dap'
                    },
                    {
                        children: (0,i18n.t)('Tin c\xf4ng nghệ'),
                        href: 'https://phongvu.vn/cong-nghe'
                    },
                    {
                        children: (0,i18n.t)('Tuyển dụng'),
                        href: 'https://help.phongvu.vn/ho-tro/tuyen-dung',
                        target: '_blank',
                        rel: 'noreferrer noopener'
                    }, 
                ]
            },
            {
                title: (0,i18n.t)('Cộng đồng Phong Vũ'),
                links: [
                    {
                        icon: {
                            name: 'logo-facebook',
                            size: 16,
                            color: '#485992'
                        },
                        children: (0,i18n.t)('Phong Vũ Việt Nam'),
                        href: 'https://phongvu.page.link/fanpage'
                    },
                    {
                        icon: {
                            name: 'logo-youtube',
                            size: 16,
                            color: '#cf2200'
                        },
                        children: 'Phong Vũ Media',
                        href: 'https://www.youtube.com/channel/UCOJ3sqWCc6koR9BScBZkBlA'
                    },
                    {
                        icon: {
                            name: 'community',
                            size: 16,
                            color: '#00AFF7'
                        },
                        children: (0,i18n.t)('Phong Vũ Hội'),
                        href: 'https://phongvu.page.link/congdong'
                    },
                    {
                        icon: {
                            name: 'support',
                            size: 16,
                            color: '#333333'
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            children: [
                                (0,i18n.t)('Gọi Mua h\xe0ng:'),
                                ' ',
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    style: {
                                        color: '#DA4343',
                                        fontWeight: 'bold'
                                    },
                                    children: clientConsultantPhone
                                }),
                                ' ',
                                (0,i18n.t)('(miễn ph\xed)')
                            ]
                        }),
                        href: "tel:".concat(clientConsultantPhone.split(' ').join(''))
                    },
                    {
                        icon: {
                            name: 'support',
                            size: 16,
                            color: '#333333'
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            children: [
                                (0,i18n.t)('Gọi Chăm s\xf3c:'),
                                ' ',
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    style: {
                                        color: '#DA4343',
                                        fontWeight: 'bold'
                                    },
                                    children: supportedPhone
                                }),
                                ' ',
                                (0,i18n.t)('(miễn ph\xed)')
                            ]
                        }),
                        href: "tel:".concat(supportedPhone.split(' ').join(''))
                    }, 
                ]
            },
            {
                title: (0,i18n.t)('Email li\xean hệ'),
                emails: [
                    {
                        children: (0,i18n.t)('Hỗ trợ Kh\xe1ch h\xe0ng:<br/>'),
                        address: 'cskh@phongvu.vn'
                    },
                    {
                        children: (0,i18n.t)('Li\xean hệ b\xe1o gi\xe1:<br/>'),
                        address: 'baogia@phongvu.vn'
                    },
                    {
                        children: (0,i18n.t)('Hợp t\xe1c ph\xe1t triển:<br/>'),
                        address: 'hoptac@phongvu.vn'
                    }, 
                ]
            }, 
        ],
        paymentMethods: {
            title: (0,i18n.t)('Phương thức thanh to\xe1n'),
            links: [
                {
                    icon: {
                        name: 'qr-code',
                        size: 30,
                        color: '#3e3e3e'
                    },
                    children: 'QR Code',
                    href: 'https://help.phongvu.vn/chinh-sach-ban-hang/huong-dan-thanh-toan-vnpay-qr',
                    link: true
                },
                {
                    icon: {
                        name: 'cash',
                        size: 30,
                        color: '#3e3e3e'
                    },
                    children: (0,i18n.t)('Tiền mặt'),
                    href: 'https://help.phongvu.vn/chinh-sach-ban-hang/phuong-thuc-thanh-toan#thanh-toan-tien-mat',
                    link: true
                },
                {
                    icon: {
                        name: 'time',
                        size: 30,
                        color: '#3e3e3e'
                    },
                    children: (0,i18n.t)('Trả g\xf3p'),
                    href: 'https://help.phongvu.vn/chinh-sach-ban-hang/phuong-thuc-thanh-toan#thanh-toan-tra-gop',
                    link: true
                },
                {
                    icon: {
                        name: 'card',
                        size: 30,
                        color: '#3e3e3e'
                    },
                    children: 'Internet Banking',
                    href: 'https://help.phongvu.vn/chinh-sach-ban-hang/phuong-thuc-thanh-toan#thanh-toan-the-atm-noi-dia-internet-banking',
                    link: true
                }, 
            ]
        },
        bankList: {
            imgSrc: 'https://phongvu.vn/media/wysiwyg/phongvu/phongvu_v3/banklist.jpg',
            mobileImgSrc: 'https://phongvu.vn/skin/frontend/default/pv_mob_amp/images/phongvu-v4/mobile-bank-list.png'
        },
        bottom: {
            company: {
                name: (0,i18n.t)('phongvu.desktop._module.Layout.data.0'),
                detail: (0,i18n.t)('phongvu.desktop._module.Layout.data.1')
            },
            address: [
                {
                    branchName: (0,i18n.t)('Địa chỉ trụ sở ch\xednh'),
                    branchAddress: (0,i18n.t)('phongvu.desktop._module.Layout.data.2')
                },
                {
                    branchName: (0,i18n.t)('Văn ph\xf2ng điều h\xe0nh miền Bắc'),
                    branchAddress: (0,i18n.t)('phongvu.desktop._module.Layout.data.3')
                },
                {
                    branchName: (0,i18n.t)('Văn ph\xf2ng điều h\xe0nh miền Nam'),
                    branchAddress: (0,i18n.t)('phongvu.desktop._module.Layout.data.4')
                }, 
            ],
            verifiedLogo: {
                logo: 'https://phongvu.vn/media/wysiwyg/phongvu/phongvu_v3/da-dang-ky.png',
                link: 'http://online.gov.vn/Home/WebDetails/4549'
            },
            dmcaId: '53b44883-ed2a-434d-902b-5adce10aafd5',
            dmcaBadgeLink: 'https://images.dmca.com/Badges/dmca-badge-w100-2x1-02.png'
        }
    };
};

// EXTERNAL MODULE: ../../.yarn/__virtual__/next-virtual-b4cbbda601/0/cache/next-npm-12.0.9-6852d2b6ac-e01e3dbe8b.zip/node_modules/next/router.js
var next_router = __webpack_require__(11686);
// EXTERNAL MODULE: ./contexts/MobioContext.tsx
var MobioContext = __webpack_require__(18548);
// EXTERNAL MODULE: ./contexts/GlobalDataContext.tsx
var GlobalDataContext = __webpack_require__(43476);
// EXTERNAL MODULE: ./tenants/_template/desktop/_module/components/NavigationBar.tsx + 11 modules
var NavigationBar = __webpack_require__(4890);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-a3f946df97/1/packages/teko-ecommerce/dist/components/Topbar/Topbar.es.js
var Topbar_es = __webpack_require__(36074);
;// CONCATENATED MODULE: ./tenants/phongvu/desktop/_module/Layout.tsx












var TopBannerWrapper = emotion_styled_browser_esm/* default.div */.Z.div(function(param) {
    var visible = param.visible;
    return "\n  height: 56px;\n  display: ".concat(visible ? 'block' : 'none', ";\n");
});
var leftMenu = [];
var invisbleTopBannerInPaths = [
    '/cart',
    '/checkout'
];
var Layout = function(param) {
    var children = param.children, banners = param.banners, liteLogo = param.liteLogo, menuItems = param.menuItems;
    var ref = (0,react.useState)(false), shouldHideTopBanners = ref[0], setShouldHideTopBanners = ref[1];
    var ref1 = (0,GlobalDataContext/* useTenantConfig */.Wx)(), contactLink = ref1.contactLink, isDisplayMessenger = ref1.isDisplayMessenger, baseDomain = ref1.baseDomain, partner = ref1.partner;
    var router = (0,next_router.useRouter)();
    var topBannersVisible = (0,react.useMemo)(function() {
        if (shouldHideTopBanners || !banners || banners && banners.length === 0) {
            return false;
        }
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = invisbleTopBannerInPaths[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var path = _step.value;
                if (router.pathname.includes(path)) {
                    return false;
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return true;
    }, [
        router.pathname,
        banners,
        shouldHideTopBanners
    ]);
    var rightMenu = getRightMenu();
    var footerData = getFooterData();
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(MobioContext/* MobioContextProvider */.t, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TopBannerWrapper, {
                visible: topBannersVisible,
                children: topBannersVisible && /*#__PURE__*/ (0,jsx_runtime.jsx)(TopBanners_es/* TopBanners */.E, {
                    banners: banners,
                    onClose: function() {
                        return setShouldHideTopBanners(true);
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Topbar_es/* Topbar */.Z, {
                leftMenu: leftMenu,
                rightMenu: rightMenu
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(NavigationBar/* NavigationBar */.v, {
                liteLogo: liteLogo,
                menuItems: menuItems,
                displayConfig: {
                    order: !partner,
                    promotion: true
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: children
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer_es/* Footer */.$, {
                footer: footerData,
                baseUrl: baseDomain
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollTopArrow_es/* ScrollTopArrow */.C, {}),
            contactLink && isDisplayMessenger && /*#__PURE__*/ (0,jsx_runtime.jsx)(Messenger_es/* Messenger */.P, {
                url: contactLink
            })
        ]
    }));
};


/***/ }),

/***/ 9221:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _utils_dom__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96045);
/* harmony import */ var _utils_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96912);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var Navigation = {
  toggleEl: function toggleEl($el, disabled) {
    $el[disabled ? 'addClass' : 'removeClass'](this.params.navigation.disabledClass);
    if ($el[0] && $el[0].tagName === 'BUTTON') $el[0].disabled = disabled;
  },
  update: function update() {
    // Update Navigation Buttons
    var swiper = this;
    var params = swiper.params.navigation;
    var toggleEl = swiper.navigation.toggleEl;
    if (swiper.params.loop) return;
    var _swiper$navigation = swiper.navigation,
        $nextEl = _swiper$navigation.$nextEl,
        $prevEl = _swiper$navigation.$prevEl;

    if ($prevEl && $prevEl.length > 0) {
      if (swiper.isBeginning) {
        toggleEl($prevEl, true);
      } else {
        toggleEl($prevEl, false);
      }

      if (swiper.params.watchOverflow && swiper.enabled) {
        $prevEl[swiper.isLocked ? 'addClass' : 'removeClass'](params.lockClass);
      }
    }

    if ($nextEl && $nextEl.length > 0) {
      if (swiper.isEnd) {
        toggleEl($nextEl, true);
      } else {
        toggleEl($nextEl, false);
      }

      if (swiper.params.watchOverflow && swiper.enabled) {
        $nextEl[swiper.isLocked ? 'addClass' : 'removeClass'](params.lockClass);
      }
    }
  },
  onPrevClick: function onPrevClick(e) {
    var swiper = this;
    e.preventDefault();
    if (swiper.isBeginning && !swiper.params.loop) return;
    swiper.slidePrev();
  },
  onNextClick: function onNextClick(e) {
    var swiper = this;
    e.preventDefault();
    if (swiper.isEnd && !swiper.params.loop) return;
    swiper.slideNext();
  },
  init: function init() {
    var swiper = this;
    var params = swiper.params.navigation;
    swiper.params.navigation = (0,_utils_utils__WEBPACK_IMPORTED_MODULE_1__/* .createElementIfNotDefined */ .Up)(swiper.$el, swiper.params.navigation, swiper.params.createElements, {
      nextEl: 'swiper-button-next',
      prevEl: 'swiper-button-prev'
    });
    if (!(params.nextEl || params.prevEl)) return;
    var $nextEl;
    var $prevEl;

    if (params.nextEl) {
      $nextEl = (0,_utils_dom__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(params.nextEl);

      if (swiper.params.uniqueNavElements && typeof params.nextEl === 'string' && $nextEl.length > 1 && swiper.$el.find(params.nextEl).length === 1) {
        $nextEl = swiper.$el.find(params.nextEl);
      }
    }

    if (params.prevEl) {
      $prevEl = (0,_utils_dom__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(params.prevEl);

      if (swiper.params.uniqueNavElements && typeof params.prevEl === 'string' && $prevEl.length > 1 && swiper.$el.find(params.prevEl).length === 1) {
        $prevEl = swiper.$el.find(params.prevEl);
      }
    }

    if ($nextEl && $nextEl.length > 0) {
      $nextEl.on('click', swiper.navigation.onNextClick);
    }

    if ($prevEl && $prevEl.length > 0) {
      $prevEl.on('click', swiper.navigation.onPrevClick);
    }

    (0,_utils_utils__WEBPACK_IMPORTED_MODULE_1__/* .extend */ .l7)(swiper.navigation, {
      $nextEl: $nextEl,
      nextEl: $nextEl && $nextEl[0],
      $prevEl: $prevEl,
      prevEl: $prevEl && $prevEl[0]
    });

    if (!swiper.enabled) {
      if ($nextEl) $nextEl.addClass(params.lockClass);
      if ($prevEl) $prevEl.addClass(params.lockClass);
    }
  },
  destroy: function destroy() {
    var swiper = this;
    var _swiper$navigation2 = swiper.navigation,
        $nextEl = _swiper$navigation2.$nextEl,
        $prevEl = _swiper$navigation2.$prevEl;

    if ($nextEl && $nextEl.length) {
      $nextEl.off('click', swiper.navigation.onNextClick);
      $nextEl.removeClass(swiper.params.navigation.disabledClass);
    }

    if ($prevEl && $prevEl.length) {
      $prevEl.off('click', swiper.navigation.onPrevClick);
      $prevEl.removeClass(swiper.params.navigation.disabledClass);
    }
  }
};
/* harmony default export */ __webpack_exports__["Z"] = ({
  name: 'navigation',
  params: {
    navigation: {
      nextEl: null,
      prevEl: null,
      hideOnClick: false,
      disabledClass: 'swiper-button-disabled',
      hiddenClass: 'swiper-button-hidden',
      lockClass: 'swiper-button-lock'
    }
  },
  create: function create() {
    var swiper = this;
    (0,_utils_utils__WEBPACK_IMPORTED_MODULE_1__/* .bindModuleMethods */ .cR)(swiper, {
      navigation: _extends({}, Navigation)
    });
  },
  on: {
    init: function init(swiper) {
      swiper.navigation.init();
      swiper.navigation.update();
    },
    toEdge: function toEdge(swiper) {
      swiper.navigation.update();
    },
    fromEdge: function fromEdge(swiper) {
      swiper.navigation.update();
    },
    destroy: function destroy(swiper) {
      swiper.navigation.destroy();
    },
    'enable disable': function enableDisable(swiper) {
      var _swiper$navigation3 = swiper.navigation,
          $nextEl = _swiper$navigation3.$nextEl,
          $prevEl = _swiper$navigation3.$prevEl;

      if ($nextEl) {
        $nextEl[swiper.enabled ? 'removeClass' : 'addClass'](swiper.params.navigation.lockClass);
      }

      if ($prevEl) {
        $prevEl[swiper.enabled ? 'removeClass' : 'addClass'](swiper.params.navigation.lockClass);
      }
    },
    click: function click(swiper, e) {
      var _swiper$navigation4 = swiper.navigation,
          $nextEl = _swiper$navigation4.$nextEl,
          $prevEl = _swiper$navigation4.$prevEl;
      var targetEl = e.target;

      if (swiper.params.navigation.hideOnClick && !(0,_utils_dom__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(targetEl).is($prevEl) && !(0,_utils_dom__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(targetEl).is($nextEl)) {
        if (swiper.pagination && swiper.params.pagination && swiper.params.pagination.clickable && (swiper.pagination.el === targetEl || swiper.pagination.el.contains(targetEl))) return;
        var isHidden;

        if ($nextEl) {
          isHidden = $nextEl.hasClass(swiper.params.navigation.hiddenClass);
        } else if ($prevEl) {
          isHidden = $prevEl.hasClass(swiper.params.navigation.hiddenClass);
        }

        if (isHidden === true) {
          swiper.emit('navigationShow');
        } else {
          swiper.emit('navigationHide');
        }

        if ($nextEl) {
          $nextEl.toggleClass(swiper.params.navigation.hiddenClass);
        }

        if ($prevEl) {
          $prevEl.toggleClass(swiper.params.navigation.hiddenClass);
        }
      }
    }
  }
});

/***/ })

}]);